/* eslint-disable no-unused-vars */
// @ts-nocheck

const python = {
  index: `
import requests

url = "{{ BASE_URL }}{{ PATH }}"

params = {"query": "Formula 1"}

headers = {"Authorization": "Bearer <api_key>"}

response = requests.get(url, headers=headers, params=params)

print(response.json())
`,
  detail: `
import requests

url = "{{ BASE_URL }}{{ PATH }}"

params = {"sdus": ["294152247252684609194428744833146550207"]}

headers = {"Authorization": "Bearer <api_key>"}

response = requests.get(url, headers=headers, params=params)

print(response.json())
`,
  peers: `
import requests

url = "{{ BASE_URL }}{{ PATH }}"
params = {"handles": ["nasa", "esa"]}

headers = {"Authorization": "Bearer <api_key>"}

response = requests.get(url, headers=headers, params=params)

print(response.json())
`,
  match: `
import requests

url = "{{ BASE_URL }}{{ PATH }}"
params = {"handles": ["nasa", "esa"]}

headers = {"Authorization": "Bearer <api_key>"}

response = requests.get(url, headers=headers, params=params)

print(response.json())
`,
};

const js = {
  index: `
const params = new URLSearchParams({ query: "Formula 1" });
const url = "{{ BASE_URL }}{{ PATH }}?" + params.toString();
const headers = { Authorization: "Bearer <api_key>" };

const response = await fetch(url, { headers });
const data = await response.json();
console.log(data);
  `,
  detail: `
const params = new URLSearchParams({ sdus: ["294152247252684609194428744833146550207"] });
const url = "{{ BASE_URL }}{{ PATH }}?" + params.toString();
const headers = { Authorization: "Bearer <api_key>" };

const response = await fetch(url, { headers });
const data = await response.json();
console.log(data);
`,
  peers: `
const params = new URLSearchParams();
["nasa", "esa"].forEach(handle => params.append("handles", handle));
const url = "{{ BASE_URL }}{{ PATH }}?" + params.toString();
const headers = { Authorization: "Bearer <api_key>" };

const response = await fetch(url, { headers });
const data = await response.json();
console.log(data);
`,
  match: `
const params = new URLSearchParams();
["nasa", "esa"].forEach(handle => params.append("handles", handle));
const url = "{{ BASE_URL }}{{ PATH }}?" + params.toString();
const headers = { Authorization: "Bearer <api_key>" };

const response = await fetch(url, { headers });
const data = await response.json();
console.log(data);
`,
};

const snippets = {
  python,
  js,
};

export default ({
  selectedLang,
  selectedServer,
  operation,
  example,
}): string | false => {
  return (
    snippets[selectedLang]?.[operation.operationId]
      ?.replace("{{ BASE_URL }}", selectedServer)
      .replace("{{ PATH }}", operation.path) || false
  );
};
